import {
  GET_BRANDS,
  GET_BRANDS_SUCCESS,
  GET_BRANDS_ERROR,
  CREATE_BRAND,
  CREATE_BRAND_ERROR,
  CREATE_BRAND_SUCCESS,
  UPDATE_CURRENT_BRAND,
  RESET_BRAND_ERROR,
  UPDATE_BRAND,
  UPDATE_BRAND_SUCCESS,
  UPDATE_BRAND_ERROR,
  GET_BRANDS_TRANSACTIONS,
  GET_BRANDS_TRANSACTIONS_SUCCESS,
  GET_BRANDS_TRANSACTIONS_ERROR
} from "./actionTypes"

export const getBrands = () => ({
  type: GET_BRANDS
})

export const getBrandsSuccess = (brand) => ({
  type: GET_BRANDS_SUCCESS,
  payload: brand
})

export const getBrandsError = (error) => ({
  type: GET_BRANDS_ERROR,
  payload: error
})

export const getBrandsTransactions = () => ({
  type: GET_BRANDS_TRANSACTIONS
})

export const getBrandsTransactionsSuccess = (brand) => ({
  type: GET_BRANDS_TRANSACTIONS_SUCCESS,
  payload: brand
})

export const getBrandsTransactionsError = (error) => ({
  type: GET_BRANDS_TRANSACTIONS_ERROR,
  payload: error
})

export const createBrand = (payload) => ({
  type: CREATE_BRAND,
  payload: payload
})

export const createBrandSuccess = (brand) => ({
  type: CREATE_BRAND_SUCCESS,
  payload: brand
})

export const createBrandError = (error) => ({
  type: CREATE_BRAND_ERROR,
  payload: error
})

export const updateCurrentBrand = (brand) => ({
  type: UPDATE_CURRENT_BRAND,
  payload: brand
})

export const updateBrand = (brand) => ({
  type: UPDATE_BRAND,
  payload: brand
})

export const updateBrandSuccess = (brand) => ({
  type: UPDATE_BRAND_SUCCESS,
  payload: brand
})

export const updateBrandError = (brand) => ({
  type: UPDATE_BRAND_ERROR,
  payload: brand
})

export const resetBrandError = () => ({
  type: RESET_BRAND_ERROR
})